import React from "react";
import { Layout, Typography, Avatar, Space, Button } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";

import styles from "./Header.module.css";
import CubesLogo from "assets/cubes.png";
import MARSLogo from "assets/mars.png";
import QuarticaLogo from "assets/quartica.png";

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = ({ user, onLogout }) => {
  return (
    <AntHeader className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.leftSection}>
          <div className={styles.logoContainer}>
            <img src={CubesLogo} alt="MARS" className={styles.marsLogo} />
          </div>
          <div className={styles.quarticaContainer}>
            <img src={MARSLogo} alt="MARS" className={styles.quarticaLogo} />
          </div>
          <Text className={styles.title}>Document Builder</Text>
        </div>

        <div className={styles.rightSection}>
          <Space size="middle">
            <div className={styles.quarticaContainer}>
              <img src={QuarticaLogo} alt="Quartica" className={styles.quarticaLogo} />
            </div>
            {user && (
              <div className={styles.userInfo}>
                <Avatar size="small" icon={<UserOutlined />} className={styles.avatar} />
                <Text className={styles.userName}>{user.name}</Text>
              </div>
            )}
            {onLogout && (
              <Button type="default" size="small" icon={<LogoutOutlined />} onClick={onLogout} className={styles.authButton}>
                Logout
              </Button>
            )}
          </Space>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;
